import React from 'react';
import ModalOverlay from '../ModalOverlay/ModalOverlay.tsx';
import styles from './OfertaInfoModal.module.scss';

interface OfertaInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const OfertaInfoModal: React.FC<OfertaInfoModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose}>
      <div className={styles.content}>
        <button
          type="button"
          className={styles.close}
          onClick={onClose}
          aria-label="Cerrar información"
        >
          ×
        </button>
        <h2 className={styles.title}>Beneficios de publicar una vacante</h2>
        <p className={styles.intro}>
          Cuando publicás una vacante en la bolsa de trabajo de Edify (para buscar profesionales que quieras contratar), obtenés:
        </p>
        <ul className={styles.list}>
          <li>Todos los postulantes tienen que tener su identidad validada para poder aplicar.</li>
          <li>En la aplicación los usuarios pueden enviar su CV, carta de presentación junto con sus datos.</li>
          <li>Todo esto te llega por mail y por notificación en la plataforma para que puedas gestionar todas las postulaciones desde ahí.</li>
        </ul>
        <div className={styles.footer}>
          <p className={styles.footerText}>
            ¿Dudas o necesitás ayuda? Abrí el{' '}
            <span className={styles.footerHighlight}>asistente con IA de edify</span>{' '}
            desde el botón redondo que ves abajo a la derecha y preguntale lo que necesites, o escribinos a{' '}
            <a href="mailto:contacto@edify.la" className={styles.footerLink}>
              contacto@edify.la
            </a>
            .
          </p>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default OfertaInfoModal;
